/*********************************************************************
* © Copyright IBM Corp. 2024
*********************************************************************/
export function getSubset<TKey, TValue>(map: Map<TKey, TValue>, ids: TKey[]) {
  const result = new Map<TKey, TValue>()

  ids.forEach((id) => {
    if (map.has(id)) {
      result.set(id, map.get(id) as TValue)
    }
  })

  return result
}
